module.exports = __webpack_public_path__ + "static/img/glasses_03.479276e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/glasses_03.png
// module id = zq80
// module chunks = 0